export type PendingRegistrationAccountKind = "sponsorship";

const PENDING_REGISTRATION_ACCOUNT_KIND_KEY =
  "terramatrix.registration.accountKind";

export const SPONSORSHIP_ACCOUNT_KIND: PendingRegistrationAccountKind =
  "sponsorship";

export const parsePendingRegistrationAccountKind = (
  value: string | null,
): PendingRegistrationAccountKind | undefined =>
  value === SPONSORSHIP_ACCOUNT_KIND ? SPONSORSHIP_ACCOUNT_KIND : undefined;

export const readPendingRegistrationAccountKind = ():
  | PendingRegistrationAccountKind
  | undefined => {
  try {
    return parsePendingRegistrationAccountKind(
      window.sessionStorage.getItem(PENDING_REGISTRATION_ACCOUNT_KIND_KEY),
    );
  } catch {
    return undefined;
  }
};

export const savePendingRegistrationAccountKind = (
  accountKind: PendingRegistrationAccountKind,
): void => {
  try {
    window.sessionStorage.setItem(
      PENDING_REGISTRATION_ACCOUNT_KIND_KEY,
      accountKind,
    );
  } catch {
    return;
  }
};

export const clearPendingRegistrationAccountKind = (): void => {
  try {
    window.sessionStorage.removeItem(PENDING_REGISTRATION_ACCOUNT_KIND_KEY);
  } catch {
    return;
  }
};
